import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear the JWT token from localStorage
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    localStorage.removeItem('isOwner');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('isGod');
    // Display a toast notification
    toast.info('You have been logged out.');
    // Redirect to the login page
    navigate('/login');
  }, [navigate]);

  return null; // No UI needed for logout
}

export default Logout;
